import { ReduxModel } from 'core/models';

const globalStoreSelector = ({ globalStore }: ReduxModel.IGlobalState) => globalStore;

const globalRequestProcessingSelector = ({
  globalStore: { requestProcessing },
}: ReduxModel.IGlobalState) => requestProcessing;

const globalTagsSelector = ({
  globalStore: {
    tags: { globaltags },
  },
}: ReduxModel.IGlobalState) => globaltags;

const availableProfilesSelector = ({
  globalStore: {
    profiles: { availableProfiles },
  },
}: ReduxModel.IGlobalState) => availableProfiles;

const navBarPositionSelector = ({
  globalStore: {
    updateNavBarCollapse,
  },
}: ReduxModel.IGlobalState) => updateNavBarCollapse;

const showErrorBoundarySelector = ({
  globalStore: { showErrorBoundary },
}: ReduxModel.IGlobalState) => showErrorBoundary;

const pendoSelector = ({
  globalStore: {
    selectedPage,
  },
}: ReduxModel.IGlobalState) => selectedPage;

const featureGatingSelector = ({
  globalStore: {
    featureGating,
  },
}: ReduxModel.IGlobalState) => featureGating;
export {
  globalStoreSelector,
  globalRequestProcessingSelector,
  globalTagsSelector,
  availableProfilesSelector,
  navBarPositionSelector,
  showErrorBoundarySelector,
  pendoSelector,
  featureGatingSelector,
};
